module.exports = __webpack_public_path__ + "static/media/single-game.a22851dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/play-screen-icons/single-game.svg
// module id = 1165
// module chunks = 0